import React  from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import             'whatwg-fetch';

export default class SearchSelect extends React.Component {
  constructor(props) {
    super(props);
    this.name = this.props.name;
    this.url = this.props.url;
    this.options = [{value: this.props.value, label: this.props.label}];

    this.state = {
      value: this.props.value
    }
  }

  getOptions = (input) => {
    return fetch(`${this.url}?q=${input}`, { credentials: 'same-origin'})
      .then((response) => {
        return response.json();
      }).then((json) => {
        return { options: json };
      });
  }

  onChange = (option) => {
    var $node = $(ReactDOM.findDOMNode(this.node));
    $node.trigger('change.SearchSelect', [option]);
    this.setState({ value: option.value });
  }

  render() {
    return (
      <Select.Async
        ref={(node) => { this.node = node }}
        name={this.name}
        value={this.state.value}
        loadOptions={this.getOptions}
        options={this.options}
        onChange={this.onChange}
        autoload={false}
        clearable={false}/>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/search_select.jsx